import React, { useState } from "react";
import { Box } from "@mui/material";
import CaseSubCategoryForm from "./form";
import { caseManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseSubCategory } from "../../../../data/Axios/queries";

const base_url = caseManagementUrl.uri;

const CaseSubCategoryColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "subcategoryName", headerName: "Subcategory Name", flex: 1.5 },
    { field: "categoryName", headerName: "Category Name", flex: 1.5 },
    { field: "description", headerName: "Description", flex: 2 },
];

const actions = {
  entity: "Case subcategory",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
    showStatus: true,
};

function CaseSubCategoryTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Case Subcategories"
          subtitle="Manage Case Subcategories"
          columns={CaseSubCategoryColumns}
          FormComponent={CaseSubCategoryForm}
          query={caseSubCategory}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}


export default CaseSubCategoryTable;